import React from 'react';


export const CargarData = () => {
  return(
    <div className='bio'>
        <h2> CARGAR DATA </h2>
    </div>
  );
};
